module.exports = __webpack_public_path__ + "img/logo-feelgood-light-linebreak.3df44821.png";